import React, {
  useState,
  ReactNode,
  CSSProperties,
  useMemo,
  PropsWithChildren,
} from 'react';
import { CustomIcon } from '@components';
import styles from './Accordion.module.scss';
import classnames from 'classnames';
import { MyCheckApp, useLocation } from 'mycheck-core';
import get from 'lodash/get';

interface AccordionProps extends PropsWithChildren {
  title: ReactNode;
  subtitle?: ReactNode;
  isOpen?: boolean;
  testId?: string;
  className?: string;
  iconStyle?: CSSProperties;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  subtitle = undefined,
  children,
  isOpen = false,
  testId,
  className,
  iconStyle,
}) => {
  const location = useLocation();
  const config = useMemo(() => {
    const _config = MyCheckApp.instance.getGlobalConfig();

    const primary = get(_config, 'palette.primary', {});

    return {
      primary,
    };
  }, [location.search]);

  const [expanded, setExpanded] = useState(isOpen);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div
      className={classnames(styles.accordion, className)}
      data-test-id={testId}
    >
      <div className={styles.header} onClick={toggleExpanded}>
        <div className={styles.headerTitleContainer}>
          {title}
          <CustomIcon
            name={document.dir === 'rtl' ? 'arrowLeft' : 'arrowRight'}
            style={{ color: config.primary, ...iconStyle }}
            className={classnames(styles.icon, { [styles.expanded]: expanded })}
          />
        </div>
        {subtitle}
      </div>
      <div
        className={classnames(styles.content, {
          [styles.open]: expanded,
          [styles.closed]: !expanded,
        })}
      >
        {children}
      </div>
    </div>
  );
};
